var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import EHandleStatus from '../../enum/EHandleStatus';
import { toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import DeliverService from '../../api/DeliverService';
import GlobalVue from "../../globalVue";
import BillSubTable from "../../components/bill/BillSubTable.vue";
import Add from './Add';
var DeliverTable = (function (_super) {
    __extends(DeliverTable, _super);
    function DeliverTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.type = 'deliver';
        _this.eBillType = EBillType;
        return _this;
    }
    DeliverTable.prototype.created = function () {
        this.service = DeliverService.getInstance();
    };
    DeliverTable.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 220;
        }, 300);
    };
    DeliverTable.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    DeliverTable.prototype.renderGetList = function () {
        this.$emit('getList');
    };
    DeliverTable.prototype.editDeliver = function (row) {
        this.addTab({
            component: Add,
            title: '修改送货单',
            showExist: true,
            name: '修改送货单' + row.order_id,
            cprops: {
                handleStatus: EHandleStatus.Edit,
                order_id: row.order_id
            }
        });
    };
    DeliverTable.prototype.selectionChange = function (val) {
        this.$emit('selectionChange', val);
    };
    DeliverTable.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.listData.indexOf(row);
        this.service.getListGoods(params).then(function (res) {
            _.forEach(res.data.data, function (item) {
                item.amount = item.order_detail_oamount;
            });
            var listGoods = res.data.data;
            listGoods.push({ isBtn: true });
            GlobalVue.$set(_this.listData[index], 'listGoods', listGoods);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    DeliverTable.prototype.toPurIn = function (row) {
        toDetail(EBillType.PurIn, row.warehouse_order_id);
    };
    DeliverTable.prototype.toPurOrder = function (order_id) {
        toDetail(EBillType.PurOrder, order_id);
    };
    DeliverTable.prototype.lookDetail = function (row) {
        toDetail(EBillType.Deliver, row.order_id);
    };
    DeliverTable.prototype.sortChange = function (pager) {
        this.$emit('sortChange', pager);
    };
    DeliverTable.prototype.ifendcase = function (val) {
        return val.c_time.toString().trim().split(" ")[0];
    };
    DeliverTable.prototype.search = function () {
        this.$emit('search');
    };
    __decorate([
        Prop({
            default: [],
            type: Array
        })
    ], DeliverTable.prototype, "listData", void 0);
    DeliverTable = __decorate([
        Component({
            components: {
                BillSubTable: BillSubTable
            },
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList',
                openedCodeData: 'openedCodeData'
            }))
        })
    ], DeliverTable);
    return DeliverTable;
}(Vue));
export default DeliverTable;
